import { useStore } from 'effector-react'
import * as React from 'react'
import { $giftCategory, createGiftCategory } from './model'

export const useCreateGiftCategory = () => {
  const giftCategory = useStore($giftCategory)
  const loading = useStore(createGiftCategory.pending)

  return { giftCategory, loading }
}
